"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameLayer = void 0;
const FixRatioContainer_1 = require("../Common/FixRatioContainer");
const Constants_1 = require("../Core/Constants");
const inversify_1 = require("inversify");
const inversify_2 = require("inversify");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const LaneLayer_1 = require("./Sublayers/LaneLayer");
const IntereactionLayer_1 = require("./Sublayers/IntereactionLayer");
const NotesLayer_1 = require("./Sublayers/NotesLayer");
const UILayer_1 = require("./Sublayers/UILayer");
const EffectLayer_1 = require("./Sublayers/EffectLayer");
const LaneEffectLayer_1 = require("./Sublayers/LaneEffectLayer");
const GameConfig_1 = require("../Core/GameConfig");
const AutoPlayLayer_1 = require("./Sublayers/AutoPlayLayer");
let GameLayer = class GameLayer extends FixRatioContainer_1.FixRatioContainer {
    constructor(ioc, events, config) {
        super(Constants_1.LayerWidth, Constants_1.LayerHeight);
        this.resize(...events.Resize.prevArgs);
        events.Resize.add((remove, w, h) => {
            if (!this.parent)
                return remove();
            this.resize(w, h);
        });
        this.addChild(ioc.resolve(LaneLayer_1.LaneLayer));
        this.addChild(ioc.resolve(LaneEffectLayer_1.LaneEffectLayer));
        this.addChild(ioc.resolve(NotesLayer_1.NotesLayer));
        this.addChild(ioc.resolve(EffectLayer_1.EffectLayer));
        this.addChild(ioc.resolve(UILayer_1.UILayer));
        this.addChild(ioc.resolve(IntereactionLayer_1.IntereactionLayer));
        if (config.autoplay) {
            this.addChild(ioc.resolve(AutoPlayLayer_1.AutoPlayLayer));
        }
    }
};
GameLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [inversify_2.Container, SymbolClasses_1.GlobalEvents, GameConfig_1.GameConfig])
], GameLayer);
exports.GameLayer = GameLayer;
//# sourceMappingURL=GameLayer.js.map